<template>
  <div>
    <div v-if="!$auth.authorized" class="auth-background">
      <div class="auth-card" :class="{ 'auth-loading': !$auth.authenticated }">
        <div class="auth-header">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="24"
          >
            <g fill="none">
              <path d="M0 0h24v24H0V0z" />
              <path d="M0 0h24v24H0V0z" opacity=".87" />
            </g>
            <path
              d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
            />
          </svg>
          <h1>Authorization Required</h1>
        </div>
        <p>Access must be granted in order to use this application.</p>
        <p class="auth-request">
          <a :href="requestUrl"> Go to Request Access </a>
        </p>
        <hr />
        <p>
          If you have recently been granted access, you may need to
          <a href="#" @click.prevent="$auth.logout">logout</a> and log back in.
        </p>
      </div>
    </div>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
import Auth from "@aws-amplify/auth"
export default {
  computed: {
    requestUrl() {
      const clientId = this.$auth.amplifyAuth.userPool.clientId
      return `https://access.fso.arizona.edu/request/${clientId}`
    },
  },
}
</script>

<style scoped lang="postcss">
.auth-loading p,
.auth-loading h1,
.auth-loading a,
.auth-loading svg {
  color: transparent !important;
  fill: transparent;
  background-color: #eee;
  border-radius: 5px;
}
.auth-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}

.auth-header svg {
  margin-right: 0.25rem;
}

.auth-header h1 {
  font-weight: 500;
  font-size: 1.5rem;
  margin: 0;
}

.auth-background {
  min-height: 70vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.auth-card {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  width: 400px;
  margin: 3rem;
  padding: 1rem;
}

.auth-request {
  text-align: center;
}
</style>
